/* Level Egypt Theme JS */
(function() {
  'use strict';

  /* === Hero Slider === */
  function initHeroSlider() {
    const slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;
    const track = slider.querySelector('[data-hero-track]');
    const slides = track.querySelectorAll('.hero-slider__slide');
    const dots = slider.querySelectorAll('[data-hero-dot]');
    const prevBtn = slider.querySelector('[data-hero-prev]');
    const nextBtn = slider.querySelector('[data-hero-next]');
    let current = 0;
    let total = slides.length;
    if (total < 2) return;

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
    }

    prevBtn?.addEventListener('click', () => goTo(current - 1));
    nextBtn?.addEventListener('click', () => goTo(current + 1));
    dots.forEach(dot => dot.addEventListener('click', () => goTo(+dot.dataset.heroDot)));

    // Autoplay
    let interval = setInterval(() => goTo(current + 1), 5000);
    slider.addEventListener('mouseenter', () => clearInterval(interval));
    slider.addEventListener('mouseleave', () => { interval = setInterval(() => goTo(current + 1), 5000); });
  }

  /* === Announcement Bar Rotation === */
  function initAnnouncement() {
    const container = document.querySelector('[data-announcement]');
    const el = document.querySelector('[data-announcement-text]');
    if (!container || !el) return;
    const text1 = container.dataset.text1 || '';
    const text2 = container.dataset.text2 || '';
    const texts = [text1, text2].filter(Boolean);
    if (texts.length < 2) return;
    let i = 0;
    setInterval(() => {
      el.style.opacity = '0';
      setTimeout(() => {
        i = (i + 1) % texts.length;
        el.textContent = texts[i];
        el.style.opacity = '1';
      }, 400);
    }, 3500);
  }

  /* === Product Quantity === */
  function initQuantity() {
    document.querySelectorAll('[data-qty-minus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.product-page__qty-wrap')?.querySelector('[data-qty-input]');
        if (input && +input.value > 1) input.value = +input.value - 1;
      });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.product-page__qty-wrap')?.querySelector('[data-qty-input]');
        if (input) input.value = +input.value + 1;
      });
    });
  }

  /* === Product Thumbnails + Slider === */
  function initThumbs() {
    const thumbs = document.querySelectorAll('[data-thumb-index]');
    const sliderTrack = document.querySelector('[data-product-slider-track]');
    if (!thumbs.length || !sliderTrack) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const idx = +thumb.dataset.thumbIndex;
        const visibleThumbs = Array.from(document.querySelectorAll('.product-page__thumb')).filter(t => !t.hidden);
      const visibleIndex = visibleThumbs.indexOf(thumb);
      const slider = document.querySelector('[data-product-slider]');
      if (slider?.goToSlide) slider.goToSlide(visibleIndex);
      else sliderTrack.style.transform = 'translateX(-' + idx * 100 + '%)';
      });
    });
  }

  /* === Product Image Slider (swipe + arrows) === */
  function initProductSlider() {
    const slider = document.querySelector('[data-product-slider]');
    if (!slider) return;
    const track = slider.querySelector('[data-product-slider-track]');
    const allSlides = Array.from(track.querySelectorAll('.product-page__slider-slide'));
let slides = allSlides;
const thumbs = Array.from(document.querySelectorAll('.product-page__thumb'));

    const prevBtn = slider.querySelector('[data-product-slider-prev]');
    const nextBtn = slider.querySelector('[data-product-slider-next]');
    let total = slides.length;
    if (total < 2) return;
    let current = 0;
    let startX = 0, diffX = 0, isDragging = false;

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, total - 1));
      track.style.transform = `translateX(-${current * 100}%)`;
      const visibleThumbs = thumbs.filter(t => !t.hidden);
      visibleThumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === current));
      const activeThumb = visibleThumbs[current];
      const strip = activeThumb?.parentElement;
      if (strip) {
        const stripRect = strip.getBoundingClientRect();
        const thumbRect = activeThumb.getBoundingClientRect();
        const centerLeft = strip.scrollLeft + thumbRect.left - stripRect.left - (strip.clientWidth - thumbRect.width) / 2;
        const centerTop = strip.scrollTop + thumbRect.top - stripRect.top - (strip.clientHeight - thumbRect.height) / 2;
        strip.scrollTo({
          left: Math.max(0, Math.min(strip.scrollWidth - strip.clientWidth, centerLeft)),
          top: Math.max(0, Math.min(strip.scrollHeight - strip.clientHeight, centerTop)),
          behavior: 'smooth'
        });
      }
    }

    slider.goToSlide = goTo;
    // Gallery images follow Shopify's variant-to-image associations only.
    const normalizeColor = value => (value || '').trim().toLocaleLowerCase();
    const matchesColor = (element, color) => {
      const image = element.querySelector('img');
      const linkedColors = element.dataset.variantColors || image?.dataset.variantColors || '';
      return linkedColors.split('||').some(value => normalizeColor(value) === normalizeColor(color));
    };
    // Group gallery media by Shopify's image-to-variant color links.
    const colorOrder = Array.from(document.querySelectorAll('.product-page__option--color [data-option-value]'))
      .map(button => button.dataset.optionValue).filter(Boolean);
    const zoomTrack = document.querySelector('[data-zoom-track]');
    const zoomSlides = Array.from(zoomTrack?.querySelectorAll('.product-zoom__slide') || []);
    if (colorOrder.length && thumbs.length === allSlides.length && zoomSlides.length === allSlides.length) {
      const thumbTrack = thumbs[0].parentElement;
      const orderedMedia = allSlides.map((slide, index) => {
        const colorIndex = colorOrder.findIndex(color => matchesColor(slide, color));
        return { slide, thumb: thumbs[index], zoom: zoomSlides[index], index,
          group: colorIndex < 0 ? colorOrder.length : colorIndex };
      }).sort((a, b) => a.group - b.group || a.index - b.index);
      orderedMedia.forEach(({ slide, thumb, zoom }, index) => {
        track.append(slide);
        thumbTrack.append(thumb);
        zoomTrack.append(zoom);
        thumb.dataset.thumbIndex = String(index);
        const image = slide.querySelector('img');
        if (image) image.dataset.zoomIndex = String(index);
      });
      allSlides.splice(0, allSlides.length, ...orderedMedia.map(item => item.slide));
      thumbs.splice(0, thumbs.length, ...orderedMedia.map(item => item.thumb));
    }
    // Keep the full gallery visible; jump to the first Shopify-linked image for this color.
    slider.goToColor = color => {
      const index = allSlides.findIndex(slide => matchesColor(slide, color));
      if (index >= 0) goTo(index);
    };
    const initialColor = document.querySelector('.product-page__option--color [data-option-value].is-active')?.dataset.optionValue;
    if (initialColor) slider.goToColor(initialColor);

    prevBtn?.addEventListener('click', (e) => { e.preventDefault(); goTo(current - 1); });
    nextBtn?.addEventListener('click', (e) => { e.preventDefault(); goTo(current + 1); });

    // Touch swipe
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
    track.addEventListener('touchmove', (e) => { if (isDragging) diffX = e.touches[0].clientX - startX; }, { passive: true });
    track.addEventListener('touchend', () => {
      if (Math.abs(diffX) > 50) {
        if (diffX < 0) goTo(current + 1);
        else goTo(current - 1);
      }
      diffX = 0; isDragging = false;
    });

    // Click image → open zoom
    allSlides.forEach(slide => {
      slide.addEventListener('click', (e) => {
        const img = e.target.closest('img');
        if (!img) return;
        const idx = +img.dataset.zoomIndex;
        if (!isNaN(idx)) openZoom(idx);
      });
    });

    window.__productCurrent = () => current;
    window.__productGoTo = goTo;
  }

  /* === Product Zoom Lightbox === */
  function openZoom(index) {
    const zoom = document.querySelector('[data-product-zoom]');
    if (!zoom) return;
    const track = zoom.querySelector('[data-zoom-track]');
    const allZoomSlides = Array.from(track.querySelectorAll('.product-zoom__slide'));
    const gallerySlides = Array.from(document.querySelectorAll('.product-page__slider-slide'));
    const visibleIndices = gallerySlides.flatMap((slide, i) => slide.hidden ? [] : [i]);
    const activeIndices = visibleIndices.length ? visibleIndices : allZoomSlides.map((_, i) => i);
    allZoomSlides.forEach((slide, i) => { slide.hidden = !activeIndices.includes(i); });
    const slides = activeIndices.map(i => allZoomSlides[i]);
    const counter = zoom.querySelector('[data-zoom-counter]');
    let total = slides.length;
    let current = Math.max(0, activeIndices.indexOf(index));

    function update() {
      track.style.transform = `translateX(-${current * 100}%)`;
      if (counter) counter.textContent = `${current + 1} / ${total}`;
    }

    zoom.classList.add('is-open');
    document.body.classList.add('zoom-open');
    update();

    // Prev/Next
    const prev = zoom.querySelector('[data-zoom-prev]');
    const next = zoom.querySelector('[data-zoom-next]');
    const close = zoom.querySelector('[data-zoom-close]');

    const prevHandler = (e) => { e.stopPropagation(); current = (current - 1 + total) % total; update(); };
    const nextHandler = (e) => { e.stopPropagation(); current = (current + 1) % total; update(); };
    const closeHandler = () => {
      zoom.classList.remove('is-open');
      document.body.classList.remove('zoom-open');
      prev?.removeEventListener('click', prevHandler);
      next?.removeEventListener('click', nextHandler);
      close?.removeEventListener('click', closeHandler);
      document.removeEventListener('keydown', keyHandler);
    };
    const keyHandler = (e) => {
      if (e.key === 'Escape') closeHandler();
      else if (e.key === 'ArrowLeft') prevHandler(e);
      else if (e.key === 'ArrowRight') nextHandler(e);
    };

    prev?.addEventListener('click', prevHandler);
    next?.addEventListener('click', nextHandler);
    close?.addEventListener('click', closeHandler);
    document.addEventListener('keydown', keyHandler);

    // Click outside (on backdrop) closes
    zoom.addEventListener('click', (e) => { if (e.target === zoom) closeHandler(); }, { once: true });

    // Swipe in zoom
    let zStartX = 0, zDiffX = 0, zDragging = false;
    track.addEventListener('touchstart', (e) => { zStartX = e.touches[0].clientX; zDragging = true; }, { passive: true });
    track.addEventListener('touchmove', (e) => { if (zDragging) zDiffX = e.touches[0].clientX - zStartX; }, { passive: true });
    track.addEventListener('touchend', () => {
      if (Math.abs(zDiffX) > 50) {
        if (zDiffX < 0) { current = (current + 1) % total; update(); }
        else { current = (current - 1 + total) % total; update(); }
      }
      zDiffX = 0; zDragging = false;
    });

    // Double-tap / click to zoom in/out
    let lastTap = 0;
    slides.forEach(slide => {
      const img = slide.querySelector('img');
      if (!img) return;

      // Double-tap on mobile
      slide.addEventListener('touchend', (e) => {
        const now = Date.now();
        if (now - lastTap < 300) {
          e.preventDefault();
          img.classList.toggle('is-zoomed');
        }
        lastTap = now;
      });

      // Click on desktop
      img.addEventListener('click', (e) => {
        e.stopPropagation();
        img.classList.toggle('is-zoomed');
      });

      // Pan while zoomed (touch)
      let panStartX = 0, panStartY = 0, imgX = 0, imgY = 0;
      slide.addEventListener('touchstart', (e) => {
        if (!img.classList.contains('is-zoomed') || e.touches.length !== 1) return;
        panStartX = e.touches[0].clientX;
        panStartY = e.touches[0].clientY;
        const transform = img.style.transform || '';
        const match = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
        imgX = match ? parseFloat(match[1]) : 0;
        imgY = match ? parseFloat(match[2]) : 0;
      }, { passive: true });

      slide.addEventListener('touchmove', (e) => {
        if (!img.classList.contains('is-zoomed') || e.touches.length !== 1) return;
        const dx = e.touches[0].clientX - panStartX;
        const dy = e.touches[0].clientY - panStartY;
        img.style.transform = 'scale(2) translate(' + (imgX + dx/2) + 'px, ' + (imgY + dy/2) + 'px)';
        img.style.transition = 'none';
        e.preventDefault();
      }, { passive: false });

      slide.addEventListener('touchend', () => {
        img.style.transition = '';
      });
    });
  }

  /* === Product Variant Selection === */
  function initVariants() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      const variantSelect = form.querySelector('[data-variant-select]');
      const groups = Array.from(form.querySelectorAll('.product-page__option'));
      if (!variantSelect || !groups.length) return;

      const variants = Array.from(variantSelect.options).map(option => ({
        option,
        values: (option.dataset.variantOptions || '').split(','),
        available: !option.disabled
      }));
      const hasStock = variants.some(variant => variant.available);
      const addButton = form.querySelector('.product-page__add-btn');
      const buyNow = form.querySelector('.product-page__buy-now-btn');
      const stock = form.querySelector('.product-page__stock');
      const buttons = group => Array.from(group.querySelectorAll('[data-option-value]'));
      const selected = () => groups.map(group => group.querySelector('[data-option-value].is-active')?.dataset.optionValue || null);
      const compatible = (values, through) => variants.some(variant => variant.available &&
        values.every((value, index) => index > through || !value || variant.values[index] === value));

      function updateVariant() {
        const values = selected();
        // Availability follows the option order: earlier choices constrain later ones.
        groups.forEach((group, index) => {
          buttons(group).forEach(button => {
            const candidate = values.slice();
            candidate[index] = button.dataset.optionValue;
            const available = compatible(candidate, index);
            button.disabled = !available;
            button.classList.toggle('is-unavailable', !available);
            if (!available) button.classList.remove('is-active');
          });
          const active = group.querySelector('[data-option-value].is-active');
          const display = group.querySelector('[data-selected-value]');
          if (display) display.textContent = active ? active.dataset.optionValue : 'Select';
        });

        const current = selected();
        const match = current.every(Boolean) ? variants.find(variant => variant.available &&
          current.every((value, index) => variant.values[index] === value)) : null;
        variantSelect.value = match ? match.option.value : '';
        if (addButton) {
          addButton.disabled = !match;
          addButton.classList.toggle('is-sold-out', !match);
          addButton.textContent = match ? 'ADD TO CART' : (hasStock ? 'SELECT AVAILABLE OPTION' : 'OUT OF STOCK');
        }
        if (buyNow) {
          buyNow.style.setProperty('display', match ? '' : 'none', match ? '' : 'important');
          buyNow.tabIndex = match ? 0 : -1;
          buyNow.setAttribute('aria-disabled', match ? 'false' : 'true');
        }
        if (stock) {
          stock.innerHTML = match
            ? '<span class="product-page__stock--in"><span class="stock-dot"></span> IN STOCK <span class="product-page__stock-sub">Ready to ship</span></span>'
            : '<span class="product-page__stock--out"><span class="stock-dot stock-dot--out"></span> ' + (hasStock ? 'SELECT AVAILABLE OPTION' : 'OUT OF STOCK') + '</span>';
        }
      }

      // Correct a stale or unavailable default combination without silently changing size.
      const initial = selected();
      groups.forEach((group, index) => {
        if (initial[index] && !compatible(initial, index)) {
          group.querySelector('[data-option-value].is-active')?.classList.remove('is-active');
          initial[index] = null;
        }
      });
      updateVariant();

      groups.forEach((group, index) => buttons(group).forEach(button => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          buttons(group).forEach(sibling => sibling.classList.remove('is-active'));
          button.classList.add('is-active');
          const values = selected();
          groups.slice(index + 1).forEach((laterGroup, offset) => {
            const laterIndex = index + offset + 1;
            if (values[laterIndex] && !compatible(values, laterIndex)) {
              laterGroup.querySelector('[data-option-value].is-active')?.classList.remove('is-active');
              values[laterIndex] = null;
            }
          });
          updateVariant();
          if (group.classList.contains('product-page__option--color')) {
            document.querySelector('[data-product-slider]')?.goToColor?.(button.dataset.optionValue);
          }
        });
      }));
    });
  }

  /* === Add to Cart (AJAX) === */
  function initAddToCart() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      const select = form.querySelector('[data-variant-select]');
      const selectedVariant = () => select?.selectedOptions[0];
      const isValid = () => !!selectedVariant() && !selectedVariant().disabled;
      const buyNow = form.querySelector('.product-page__buy-now-btn');
      if (buyNow) buyNow.addEventListener('click', async event => {
        event.preventDefault();
        if (!isValid()) return;
        buyNow.style.pointerEvents = 'none';
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
          if (!response.ok) throw new Error('Variant unavailable');
          window.location.href = '/checkout';
        } catch {
          buyNow.style.pointerEvents = '';
          buyNow.textContent = 'PLEASE TRY AGAIN';
          setTimeout(() => { buyNow.textContent = 'BUY IT NOW'; }, 2000);
        }
      });

      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!isValid()) return;
        const button = form.querySelector('.product-page__add-btn');
        if (!button) return;
        const originalText = button.textContent;
        button.textContent = 'Adding...';
        button.disabled = true;
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
          if (!response.ok) throw new Error('Variant unavailable');
          button.textContent = 'Added ✓';
          const cartResponse = await fetch('/cart.js');
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
          }
          setTimeout(() => { button.textContent = originalText; button.disabled = !isValid(); }, 2000);
        } catch {
          button.textContent = 'UNAVAILABLE — TRY ANOTHER OPTION';
          setTimeout(() => { button.textContent = originalText; button.disabled = !isValid(); }, 2000);
        }
      });
    });
  }

  /* === Mobile Drawer — handled by inline script in theme.liquid === */
  function initDrawer() {
    // Intentionally empty. Inline script in theme.liquid handles drawer open/close
    // to guarantee it works on ALL templates (even before theme.js loads).
    return;
  }

  /* === Section Tabs (event delegation) === */
  function initSectionTabs() {
    document.body.addEventListener('click', (e) => {
      const tab = e.target.closest('.section-tabs__tab');
      if (!tab) return;
      const tabsContainer = tab.closest('[data-section-tabs]');
      if (!tabsContainer) return;
      const section = tabsContainer.closest('section');
      if (!section) return;
      const target = tab.dataset.tabTarget;
      tabsContainer.querySelectorAll('.section-tabs__tab').forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      section.querySelectorAll('[data-tab-panel]').forEach(p => {
        p.classList.toggle('is-active', p.dataset.tabPanel === target);
      });
      // Toggle per-tab View All CTA
      section.querySelectorAll('[data-tab-cta]').forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.tabCta === target);
      });
    });
  }

  /* === Collections Slider (auto-slide every 2800ms + drag + touch) === */
  function initCollectionsSlider() {
    document.querySelectorAll('[data-collections-slider]').forEach(function(slider) {
      var cardW = function() {
        var first = slider.querySelector('.collections-grid__card');
        return first ? first.offsetWidth + 10 : 155;
      };

      var isPaused = false;
      var autoInterval = null;

      function tick() {
        if (isPaused) return;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (maxScroll <= 0) return;
        if (slider.scrollLeft >= maxScroll - 2) {
          slider.scrollLeft = 0;
        } else {
          var target = slider.scrollLeft + cardW();
          // smooth scroll manually
          var start = slider.scrollLeft;
          var diff = target - start;
          var startTime = null;
          function step(ts) {
            if (!startTime) startTime = ts;
            var progress = Math.min((ts - startTime) / 400, 1);
            slider.scrollLeft = start + diff * progress;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }
      }

      function startAuto() {
        stopAuto();
        autoInterval = setInterval(tick, 2800);
      }
      function stopAuto() { clearInterval(autoInterval); }

      // Start after short delay to ensure DOM is ready
      setTimeout(startAuto, 500);

      // Pause on hover
      slider.addEventListener('mouseenter', function() { isPaused = true; });
      slider.addEventListener('mouseleave', function() { isPaused = false; });

      // Pause on touch
      slider.addEventListener('touchstart', function() { isPaused = true; stopAuto(); }, { passive: true });
      slider.addEventListener('touchend', function() { isPaused = false; startAuto(); }, { passive: true });

      // Drag (desktop)
      var isDown = false, startX = 0, scrollLeft = 0;
      slider.addEventListener('mousedown', function(e) {
        isDown = true; isPaused = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.style.cursor = 'grabbing';
      });
      slider.addEventListener('mouseleave', function() { isDown = false; slider.style.cursor = 'grab'; });
      slider.addEventListener('mouseup', function() { isDown = false; slider.style.cursor = 'grab'; isPaused = false; });
      slider.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        slider.scrollLeft = scrollLeft - (e.pageX - slider.offsetLeft - startX) * 1.5;
      });

      // Touch swipe
      var touchStartX = 0;
      slider.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchmove', function(e) {
        var diff = touchStartX - e.touches[0].clientX;
        slider.scrollLeft += diff * 0.5;
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
    });
  }

  /* === Wishlist (localStorage-backed) === */
  var WL_KEY = 'level_wishlist_v1';

  function wlRead() {
    try {
      var raw = localStorage.getItem(WL_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function wlWrite(arr) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(arr)); } catch (e) {}
    wlBroadcast(arr);
  }
  function wlBroadcast(arr) {
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: arr } }));
  }
  function wlHas(id) {
    return wlRead().some(function(i) { return String(i.id) === String(id); });
  }
  function wlToggle(item) {
    var arr = wlRead();
    var idx = arr.findIndex(function(i) { return String(i.id) === String(item.id); });
    if (idx >= 0) arr.splice(idx, 1);
    else arr.unshift(item);
    wlWrite(arr);
    return idx < 0; // true if added
  }
  function wlRemove(id) {
    var arr = wlRead().filter(function(i) { return String(i.id) !== String(id); });
    wlWrite(arr);
  }
  function wlClear() {
    wlWrite([]);
  }

  function wlReadCardItem(card) {
    return {
      id: card.dataset.productId,
      handle: card.dataset.productHandle,
      title: card.dataset.productTitle,
      vendor: card.dataset.productVendor,
      url: card.dataset.productUrl,
      image: card.dataset.productImage,
      price: card.dataset.productPrice,
      compare: card.dataset.productCompare,
      available: card.dataset.productAvailable === 'true'
    };
  }

  function wlMarkCards() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var card = btn.closest('[data-product-id]');
      if (!card) return;
      btn.classList.toggle('is-active', wlHas(card.dataset.productId));
    });
  }

  function wlUpdateHeaderBadge() {
    var count = wlRead().length;
    document.querySelectorAll('[data-wishlist-badge]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function wlRenderPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    var toolbar = document.querySelector('[data-wishlist-toolbar]');
    var countEl = document.querySelector('[data-wishlist-count]');
    if (!grid) return;

    var items = wlRead();

    if (countEl) countEl.textContent = items.length + (items.length === 1 ? ' item' : ' items');

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (toolbar) toolbar.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (toolbar) toolbar.hidden = false;

    grid.innerHTML = items.map(function(it) {
      var img = it.image
        ? '<img src="' + it.image + '" alt="' + escapeHtml(it.title) + '" loading="lazy" class="wl-card__img">'
        : '<div class="wl-card__placeholder" aria-hidden="true"></div>';
      var comparePart = it.compare
        ? '<span class="wl-card__price-compare">' + escapeHtml(it.compare) + '</span>'
        : '';
      return ''
        + '<div class="wl-card" data-wl-item="' + escapeHtml(it.id) + '">'
        +   '<a href="' + escapeHtml(it.url || '#') + '" class="wl-card__img-wrap">' + img + '</a>'
        +   '<button type="button" class="wl-card__remove" data-wl-remove="' + escapeHtml(it.id) + '" aria-label="Remove from wishlist">'
        +     '<svg viewBox="0 0 24 24"><path d="M18.3 5.71 12 12.01l-6.3-6.3-1.41 1.41L10.59 13.4l-6.3 6.3 1.41 1.41L12 14.83l6.3 6.3 1.41-1.41-6.3-6.3 6.3-6.3z"/></svg>'
        +   '</button>'
        +   '<div class="wl-card__info">'
        +     '<p class="wl-card__vendor">' + escapeHtml(it.vendor || 'LEVEL SHOES') + '</p>'
        +     '<h3 class="wl-card__title">' + escapeHtml(it.title || '') + '</h3>'
        +     '<div class="wl-card__price">'
        +       '<span class="wl-card__price-current">' + escapeHtml(it.price || '') + '</span>'
        +       comparePart
        +     '</div>'
        +     '<div class="wl-card__actions">'
        +       '<a href="' + escapeHtml(it.url || '#') + '" class="wl-card__view">View Product</a>'
        +     '</div>'
        +   '</div>'
        + '</div>';
    }).join('');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initWishlist() {
    // Click handler for heart buttons on product cards
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        e.preventDefault();
        var card = btn.closest('[data-product-id]');
        if (!card) return;
        var item = wlReadCardItem(card);
        var added = wlToggle(item);
        btn.classList.toggle('is-active', added);
        return;
      }
      var removeBtn = e.target.closest('[data-wl-remove]');
      if (removeBtn) {
        e.preventDefault();
        wlRemove(removeBtn.dataset.wlRemove);
        return;
      }
      var clearBtn = e.target.closest('[data-wishlist-clear]');
      if (clearBtn) {
        e.preventDefault();
        if (confirm('Clear your entire wishlist?')) wlClear();
      }
    });

    // React to changes (from any tab)
    document.addEventListener('wishlist:change', function() {
      wlMarkCards();
      wlUpdateHeaderBadge();
      if (document.querySelector('[data-wishlist-grid]')) wlRenderPage();
    });
    window.addEventListener('storage', function(e) {
      if (e.key === WL_KEY) {
        wlMarkCards();
        wlUpdateHeaderBadge();
        if (document.querySelector('[data-wishlist-grid]')) wlRenderPage();
      }
    });

    // Initial paint
    wlMarkCards();
    wlUpdateHeaderBadge();
    if (document.querySelector('[data-wishlist-grid]')) wlRenderPage();
  }

  /* === Collection Filters Drawer === */
  function initFilters() {
    var drawer = document.querySelector('[data-filter-drawer]');
    var openBtn = document.querySelector('[data-filter-open]');
    var sortSelect = document.querySelector('[data-sort-select]');
    var form = document.getElementById('FilterForm');

    function open() {
      if (!drawer) return;
      drawer.hidden = false;
      // force reflow then add open class so transition runs
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function() { drawer.hidden = true; }, 260);
    }

    if (openBtn) openBtn.addEventListener('click', function(e) { e.preventDefault(); open(); });

    if (drawer) {
      drawer.querySelectorAll('[data-filter-close]').forEach(function(el) {
        el.addEventListener('click', function(e) { e.preventDefault(); close(); });
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    }

    // Apply filters — reload with selected params
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        applyFilters();
      });
    }

    // Sort dropdown — reload with sort_by param preserved with existing filters
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        // reset page number on sort change
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    function applyFilters() {
      var base = window.location.pathname;
      var params = new URLSearchParams();
      // Keep sort
      if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);

      // Collect checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
        params.append(cb.name, cb.value);
      });
      // Price range numbers
      form.querySelectorAll('input[type="number"]').forEach(function(inp) {
        if (inp.value !== '' && inp.value !== null) params.set(inp.name, inp.value);
      });

      var query = params.toString();
      window.location.href = base + (query ? '?' + query : '');
    }
  }

  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(el => {
      const endAttr = el.dataset.end;
      if (!endAttr) return;
      const endTime = new Date(endAttr).getTime();
      if (isNaN(endTime)) return;

      const daysEl = el.querySelector('[data-count-days]');
      const hoursEl = el.querySelector('[data-count-hours]');
      const minsEl = el.querySelector('[data-count-mins]');
      const secsEl = el.querySelector('[data-count-secs]');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        const now = Date.now();
        const diff = endTime - now;
        if (diff <= 0) {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minsEl) minsEl.textContent = '00';
          if (secsEl) secsEl.textContent = '00';
          return;
        }
        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diff % (1000 * 60)) / 1000);
        if (daysEl) daysEl.textContent = pad(d);
        if (hoursEl) hoursEl.textContent = pad(h);
        if (minsEl) minsEl.textContent = pad(m);
        if (secsEl) secsEl.textContent = pad(s);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* === Money formatter (client-side) === */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseFloat(cents.replace('.', '')) || 0;
    var value = (cents / 100);
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || 'EGP {{amount}}';
    function defaultOption(opt, def) { return (opt === null || opt === undefined) ? def : opt; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      precision = defaultOption(precision, 2);
      if (isNaN(number) || number == null) return 0;
      number = (number / 1).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    var match = formatString.match(placeholder);
    if (!match) return 'EGP ' + formatWithDelimiters(value * 100, 2);
    var key = match[1];
    var out;
    switch (key) {
      case 'amount': out = formatWithDelimiters(value * 100, 2); break;
      case 'amount_no_decimals': out = formatWithDelimiters(value * 100, 0); break;
      case 'amount_with_comma_separator': out = formatWithDelimiters(value * 100, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = formatWithDelimiters(value * 100, 0, '.', ','); break;
      default: out = formatWithDelimiters(value * 100, 2);
    }
    return formatString.replace(placeholder, out);
  }

  /* === Fetch all products from a collection across pages === */
  async function fetchCollectionProducts(handle, maxPages) {
    var all = [];
    var page = 1;
    var limit = 50;
    maxPages = maxPages || 6; // 6 × 50 = 300 products max
    var base = '/collections/' + encodeURIComponent(handle) + '/products.json';
    try {
      while (page <= maxPages) {
        // Request newest-first explicitly (falls back to default if not supported)
        var url = base + '?limit=' + limit + '&page=' + page + '&order=created-descending';
        var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) break;
        var data = await res.json();
        var batch = (data && data.products) || [];
        if (!batch.length) break;
        all = all.concat(batch);
        if (batch.length < limit) break;
        page++;
      }
    } catch (e) { console.warn('fetchCollectionProducts failed', e); }
    return all;
  }

  /* === Build deal/product card HTML (unified with server markup) === */
  function buildDealCard(p, moneyFmt) {
    var price = (p.variants && p.variants[0] && p.variants[0].price) ? p.variants[0].price : null;
    var compare = (p.variants && p.variants[0] && p.variants[0].compare_at_price) ? p.variants[0].compare_at_price : null;
    if (!price) return '';
    var priceCents = Math.round(parseFloat(price) * 100);
    var compareCents = compare ? Math.round(parseFloat(compare) * 100) : 0;
    var pct = compareCents > priceCents
      ? Math.round((compareCents - priceCents) * 100 / compareCents)
      : 0;
    var imageUrl = '';
    if (p.images && p.images[0]) {
      imageUrl = p.images[0].src ? p.images[0].src.replace(/(\.[a-z]{3,4})(\?|$)/, '_400x$1$2') : '';
    } else if (p.featured_image) {
      imageUrl = p.featured_image;
    }
    var url = '/products/' + p.handle;
    var variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
    return ''
      + '<div class="deals__card" data-product-id="' + p.id + '">'
      +   '<a href="' + url + '" class="deals__card-link">'
      +     '<div class="deals__card-image">'
      +       (imageUrl ? '<img src="' + imageUrl + '" alt="' + escapeAttr(p.title) + '" loading="lazy">' : '')
      +       (pct > 0 ? '<span class="deals__badge">-' + pct + '%</span>' : '')
      +     '</div>'
      +     '<div class="deals__card-info">'
      +       '<p class="deals__card-vendor">' + escapeHtmlLocal(p.vendor || '') + '</p>'
      +       '<h3 class="deals__card-title">' + escapeHtmlLocal(p.title || '') + '</h3>'
      +       '<div class="deals__card-price">'
      +         '<span class="deals__price-current">' + formatMoney(priceCents, moneyFmt) + '</span>'
      +         (compareCents > priceCents ? '<span class="deals__price-compare">' + formatMoney(compareCents, moneyFmt) + '</span>' : '')
      +       '</div>'
      +     '</div>'
      +   '</a>'
      +   '<button class="deals__add-btn" data-product-id="' + variantId + '">Add to Cart</button>'
      + '</div>';
  }

  function escapeHtmlLocal(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtmlLocal(s); }

  /* === Deals Auto-Load (all on-sale products) === */
  /* === Deals: fully server-rendered via Liquid — JS disabled === */
  async function initDealsAuto() {
    // Intentionally empty. The deals section renders server-side via Liquid
    // and only shows products where compare_at_price > price.
    return;
  }

  /* === Detect audience from any combination of product signals === */
  function productMatchesAudience(p, audience) {
    if (!audience) return true;
    var tagsArr = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    var signalText = [
      (p.title || ''),
      (p.handle || ''),
      (p.product_type || ''),
      (p.vendor || ''),
      tagsArr.join(' ')
    ].join(' ').toLowerCase();

    // Protect against "woman" matching "man" by checking the longer word first
    if (audience === 'kids' || audience === 'kid') {
      return /(^|[\s\-_/])(kids?|children|child|boys?|girls?|infant|baby|junior)([\s\-_/]|$)/.test(signalText);
    }
    if (audience === 'woman' || audience === 'women') {
      return /(^|[\s\-_/])(women|woman|female|ladies|lady|girl|girls)([\s\-_/]|$)/.test(signalText);
    }
    if (audience === 'man' || audience === 'men') {
      // Must match man/men but NOT women/woman
      if (/(^|[\s\-_/])(women|woman|ladies|lady|girl|girls|kids?|children)([\s\-_/]|$)/.test(signalText)) return false;
      return /(^|[\s\-_/])(men|man|male|boys?|gents|gentleman)([\s\-_/]|$)/.test(signalText);
    }
    return true;
  }

  /* === New Arrivals Auto (newest published products across the whole store) === */
  async function initNewArrivalsAuto() {
    var sections = document.querySelectorAll('[data-new-arrivals-auto]');
    if (!sections.length) return;

    sections.forEach(async function(section) {
      var track = section.querySelector('[data-product-slider]') || section.querySelector('.product-grid');
      if (!track) return;
      var handle = section.dataset.sourceHandle || 'all';
      var audience = (section.dataset.audience || '').toLowerCase();
      var limit = parseInt(section.dataset.limit || '8', 10);
      var moneyFmt = section.dataset.moneyFormat || 'EGP {{amount}}';

      var products = await fetchCollectionProducts(handle, 10); // up to 500 products
      if (!products.length) return;

      // Sort by newest (created_at desc)
      products.sort(function(a, b) {
        var ad = new Date(a.created_at || a.published_at || 0).getTime();
        var bd = new Date(b.created_at || b.published_at || 0).getTime();
        return bd - ad;
      });

      // Filter by audience using robust signal detection
      if (audience) {
        products = products.filter(function(p) { return productMatchesAudience(p, audience); });
      }

      var slice = products.slice(0, limit);
      if (!slice.length) return; // keep server-rendered cards

      // For New Arrivals, ALWAYS replace with JS-sorted latest-first list
      // (server's Liquid sort can be unreliable on large collections)
      track.innerHTML = slice.map(function(p) { return buildDealCard(p, moneyFmt); }).join('');
    });
  }

  /* === Universal Interactive Marquee ===
     Track is the scroll container. Auto-scroll + drag/swipe.
  */
  function initInteractiveMarquees() {
    document.querySelectorAll('[data-interactive-marquee]').forEach(function(track) {
      var isPaused = false;
      var isUserInteracting = false;
      var userResumeTimeout = null;
      var accumulator = 0;
      var speed = 1.2; // px per frame (scroll only integers, so use accumulator for sub-pixel smoothness)

      function getLoopWidth() {
        var firstGroup = track.querySelector('.shop-by-brand__group, .collections-grid__marquee-group, .deals__marquee-group');
        return firstGroup ? firstGroup.offsetWidth : 800;
      }

      function animate() {
        if (!isPaused && !isUserInteracting) {
          accumulator += speed;
          if (accumulator >= 1) {
            var pxToAdd = Math.floor(accumulator);
            accumulator -= pxToAdd;
            var newPos = track.scrollLeft + pxToAdd;
            var loopW = getLoopWidth();
            if (newPos >= loopW) newPos -= loopW;
            track.scrollLeft = newPos;
          }
        }
        requestAnimationFrame(animate);
      }
      requestAnimationFrame(animate);

      // Pause on hover (desktop only)
      track.addEventListener('mouseenter', function() { isPaused = true; });
      track.addEventListener('mouseleave', function() { isPaused = false; });

      // Touch: pause while user is touching, resume after release
      track.addEventListener('touchstart', function() {
        isUserInteracting = true;
        clearTimeout(userResumeTimeout);
      }, { passive: true });

      track.addEventListener('touchend', function() {
        userResumeTimeout = setTimeout(function() {
          isUserInteracting = false;
          // Normalize scroll position after user release
          var loopW = getLoopWidth();
          if (track.scrollLeft >= loopW) track.scrollLeft -= loopW;
          if (track.scrollLeft < 0) track.scrollLeft += loopW;
        }, 1000);
      }, { passive: true });

      track.addEventListener('touchcancel', function() {
        userResumeTimeout = setTimeout(function() { isUserInteracting = false; }, 500);
      });

      // Mouse drag (desktop)
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;
      var hasDragged = false;

      track.addEventListener('mousedown', function(e) {
        if (e.button !== 0) return;
        isDragging = true;
        isUserInteracting = true;
        hasDragged = false;
        startX = e.pageX;
        startScroll = track.scrollLeft;
        track.style.cursor = 'grabbing';
        e.preventDefault();
      });
      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        var delta = e.pageX - startX;
        if (Math.abs(delta) > 4) hasDragged = true;
        track.scrollLeft = startScroll - delta;
      });
      document.addEventListener('mouseup', function() {
        if (!isDragging) return;
        isDragging = false;
        track.style.cursor = '';
        setTimeout(function() {
          isUserInteracting = false;
          var loopW = getLoopWidth();
          if (track.scrollLeft >= loopW) track.scrollLeft -= loopW;
          if (track.scrollLeft < 0) track.scrollLeft += loopW;
        }, 800);
      });

      // Click guard
      track.addEventListener('click', function(e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          hasDragged = false;
        }
      }, true);
    });
  }

  /* === Cart Page Functions === */
  function initCartPage() {
    // 1. Remove item button handler
    document.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const itemKey = btn.dataset.cartRemove;
        const itemElement = btn.closest('[data-cart-item]');
        
        if (itemElement) {
          itemElement.style.opacity = '0.5';
          itemElement.style.pointerEvents = 'none';
        }
        
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: 0
            })
          });
          if (res.ok) {
            window.location.reload();
          } else {
            throw new Error('Failed to remove item');
          }
        } catch (err) {
          console.error(err);
          if (itemElement) {
            itemElement.style.opacity = '';
            itemElement.style.pointerEvents = '';
          }
          alert('Error updating cart. Please try again.');
        }
      });
    });

    // 2. Quantity buttons handler
    document.querySelectorAll('[data-qty-change]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const itemKey = btn.dataset.qtyChange;
        const dir = btn.dataset.qtyDir;
        const itemElement = btn.closest('[data-cart-item]');
        const qtyValueEl = itemElement?.querySelector('.cart-page__qty-value');
        if (!qtyValueEl || !itemElement) return;

        let currentQty = parseInt(qtyValueEl.textContent.trim(), 10);
        if (isNaN(currentQty)) return;

        let newQty = dir === 'plus' ? currentQty + 1 : currentQty - 1;
        if (newQty < 0) newQty = 0;

        // Apply visual loading state
        itemElement.style.opacity = '0.5';
        itemElement.style.pointerEvents = 'none';

        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: itemKey,
              quantity: newQty
            })
          });
          if (res.ok) {
            window.location.reload();
          } else {
            throw new Error('Failed to update quantity');
          }
        } catch (err) {
          console.error(err);
          itemElement.style.opacity = '';
          itemElement.style.pointerEvents = '';
          alert('Error updating cart. Please try again.');
        }
      });
    });
  }

  /* === Init === */
  document.addEventListener('DOMContentLoaded', () => {
    initHeroSlider();
    initAnnouncement();
    initQuantity();
    initThumbs();
    initProductSlider();
    initVariants();
    initAddToCart();
    initDrawer();
    initSectionTabs();
    initCountdown();
    initCollectionsSlider();
    initWishlist();
    initFilters();
    initDealsAuto();
    initCartPage();
  });
})();

/* Product-card color previews use the image linked to each Shopify color variant. */
document.addEventListener('click', function (event) {
  const swatch = event.target.closest('[data-card-color]');
  if (!swatch) return;
  event.preventDefault();
  event.stopPropagation();
  const card = swatch.closest('.product-card');
  const image = card?.querySelector('.product-card__image img');
  const imageUrl = swatch.dataset.colorImage;
  if (!card || !image || !imageUrl) return;

  card.querySelectorAll('[data-card-color]').forEach(button => {
    const active = button === swatch;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  const label = card.querySelector('[data-card-color-label]');
  if (label) label.textContent = swatch.dataset.colorName || 'COLORS';
  image.src = imageUrl;
  image.removeAttribute('srcset');
  card.dataset.productImage = imageUrl;
  const link = card.querySelector('.product-card__link');
  if (link && swatch.dataset.colorVariant) {
    const target = new URL(link.href, window.location.origin);
    target.searchParams.set('variant', swatch.dataset.colorVariant);
    link.href = target.toString();
    card.dataset.productUrl = link.href;
  }
});

/* On touch/mobile, reveal the light card prompt on the first tap; follow the product link on the next tap. */
const productCardTapView = window.matchMedia('(hover: none), (max-width: 640px)');
document.addEventListener('click', function (event) {
  if (!productCardTapView.matches || event.detail === 0) return;
  const link = event.target.closest('.product-card__link');
  if (!link) {
    document.querySelectorAll('.product-card.is-buy-open').forEach(card => card.classList.remove('is-buy-open'));
    return;
  }
  const card = link.closest('.product-card');
  if (!card || !card.querySelector('.product-card__buy-now') || card.classList.contains('is-buy-open')) return;
  event.preventDefault();
  document.querySelectorAll('.product-card.is-buy-open').forEach(openCard => openCard.classList.remove('is-buy-open'));
  card.classList.add('is-buy-open');
});


/* Level Shoes appearance switch: one preference across all storefront pages. */
(function () {
  var storageKey = 'level-color-mode';
  function initThemeToggle() {
    var host = document.querySelector('.header__right');
    if (!host || host.querySelector('[data-level-theme-toggle]')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'level-theme-toggle';
    button.setAttribute('data-level-theme-toggle', '');
    button.innerHTML = '<svg class="level-theme-toggle__moon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.2 15.3A8.5 8.5 0 0 1 8.7 3.8 8.6 8.6 0 1 0 20.2 15.3Z"/></svg>' +
      '<svg class="level-theme-toggle__sun" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';
    host.insertBefore(button, host.querySelector('.header__icon--wishlist') || host.querySelector('.header__cart'));

    function sync() {
      var dark = document.documentElement.classList.contains('level-dark');
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
      button.title = dark ? 'Light mode' : 'Dark mode';
      var meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.setAttribute('content', dark ? '#211d18' : '#4a3d2b');
    }
    button.addEventListener('click', function () {
      var dark = document.documentElement.classList.toggle('level-dark');
      try { localStorage.setItem(storageKey, dark ? 'dark' : 'light'); } catch (e) {}
      sync();
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initThemeToggle);
  else initThemeToggle();
})();
